import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

interface SectionProps extends HTMLAttributes<HTMLElement> {
  /** Render with the very-light-gray banded background. */
  muted?: boolean;
  /** Add the subtle teal/blue radial accent background. */
  accent?: boolean;
}

/** Standardised vertical rhythm wrapper for page sections. */
export function Section({
  className,
  muted = false,
  accent = false,
  children,
  ...props
}: SectionProps) {
  return (
    <section
      className={cn(
        "py-16 sm:py-20 lg:py-24",
        muted && "bg-muted",
        accent && "section-accent",
        className,
      )}
      {...props}
    >
      {children}
    </section>
  );
}
